import React from "react";
import {
  Route,
  Routes,
  BrowserRouter as Router,
  Navigate,
} from "react-router-dom";
import { Provider } from "react-redux";
import { store } from "./redux/store";

// Common
import SignIn from "./pages/SignIn/SignIn";
import SignUp from "./pages/SignUp/SignUp";
import ForgotPassword from "./pages/ForgotPassword/ForgotPassword";
import Main from "./pages/Main/Main";
import NotFound from "./pages/NotFound/NotFound";
import PermissionDenied from "./pages/PermissionDenied/PermissionDenied";
// Users
import QRManagement from "./pages/User/QRManagement/QRManagement";
import DiscountManagement from "./pages/User/DiscountManagement/DiscountManagement";
import QRUsers from "./pages/User/QRUsers/QRUsers";
import SalesInformation from "./pages/User/SalesInfo/SalesInformation";
import MyMenuOrders from "./pages/User/MyMenuOrders/MyMenuOrders";
import OrdersЕxecution from "./pages/User/OrdersЕxecution/OrdersЕxecution";
import UsersReports from "./pages/User/UsersReports/UsersReports";
import Users from "./pages/Admin/Users/Users";
import DiscountReferences from "./pages/User/DiscountsReferences/DiscountReferences";
import TablesInfo from "./pages/User/TablesInfo/TablesInfo";
import UnrealSoftManager from "./pages/User/UnrealSoftManager/UnrealSoftManager";
import Dashboard from "./pages/User/Dashboard/Dashboard";
import MenuConfigurations from "./pages/User/MenuConfiguration/MenuConfigurations";
import WaitersInfo from "./pages/User/WaitersInfo/WaitersInfo";
import AreasInfo from "./pages/User/AreasInfo/AreasInfo";
import Changelog from "./pages/User/Changelog/Changelog";
import ReportsInfo from "./pages/User/ReportsInfo/ReportsInfo";
import OrdersInfo from "./pages/User/OrdersInfo/OrdersInfo";
import RestaurantSchema from "./pages/User/RestaurantSchema/RestaurantSchema";
import Reservations from "./pages/User/Reservations/Reservations";
import ReservationsTableView from "./pages/User/ReservationsTableView/ReservationsTableView";
import ReservationHistory from "./pages/User/ReservationHistory/ReservationHistory";
import MyMenuSurvey from "./pages/User/MyMenuSurvey/MyMenuSurvey";
import TablesEfficiency from "./pages/User/TablesEfficiency/TablesEfficiency";
import ProductProfitability from "./pages/User/ProductProfitability/ProductProfitability";
import Invoices from "./pages/User/Invoices/Invoices";

// Admin
import Organizations from "./pages/Admin/Organizations/Organizations";
import OrganizationsStatistics from "./pages/Admin/OrganizationsStatistics/OrganizationsStatistics";
import StatisticsTime from "./pages/Admin/StatisticsTime/StatisticsTime";
import LogsHistory from "./pages/Admin/LogsHistory/LogsHistory";

import { StateProvider } from "./context/stateContext";
import "./i18n";

const App = () => {
  const accessInformation = JSON.parse(
    localStorage.getItem("accessInformation")
  );

  const isLogin = localStorage.getItem("id_token") !== null;

  const ProtectAuthRouter = ({ children }) => {
    // Validation if we are login already but try to access /signin, /signup or /forgotpassword

    if (localStorage.getItem("id_token") !== null) {
      window.location = `/${accessInformation[0].urls[0].url}`;
    } else {
      return children;
    }
  };

  const ProtectedRoute = ({ children, requiredAccess }) => {
    // Check if we have permission to access the page `requiredAccess`

    const hasAccess = accessInformation.some((accessGroup) =>
      accessGroup.urls.some((url) => url.url === requiredAccess)
    );

    if (!hasAccess) {
      window.location = `/not-found`;
    } else {
      return children;
    }
  };

  return (
    <Provider store={store}>
      <StateProvider>
        <Router>
          <Routes>
            <Route path="/" element={<Main />}>
              {/* If somebody try to access '/' redirect it to the first access page or to signin */}
              <Route
                path="/"
                element={
                  isLogin ? (
                    <Navigate
                      to={
                        accessInformation !== null &&
                        accessInformation?.length !== 0
                          ? `/${accessInformation[0].urls[0].url}`
                          : "/permission-denied"
                      }
                    />
                  ) : (
                    <Navigate to="/signin" />
                  )
                }
              />
              {/* If somebody try to access page that do not exist redirect it to the first access page or to signin */}
              <Route
                path="/*"
                element={
                  isLogin ? (
                    <Navigate
                      to={
                        accessInformation !== null &&
                        accessInformation?.length !== 0
                          ? `/${accessInformation[0].urls[0].url}`
                          : "/permission-denied"
                      }
                    />
                  ) : (
                    <Navigate to="/signin" />
                  )
                }
              />
              {/* <Route path="/*" element={<Navigate to="/not-found" />} /> */}
              <Route exact path="/not-found" element={<NotFound />} />
              <Route
                exact
                path="/permission-denied"
                element={<PermissionDenied />}
              />

              {isLogin && (
                <>
                  <Route
                    exact
                    path="/organizations"
                    element={
                      <ProtectedRoute requiredAccess="organizations">
                        <Organizations />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    exact
                    path="/users"
                    element={
                      <ProtectedRoute requiredAccess="users">
                        <Users />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    exact
                    path="/logs"
                    element={
                      <ProtectedRoute requiredAccess="logs">
                        <LogsHistory />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    exact
                    path="/organizations/statistics"
                    element={
                      <ProtectedRoute requiredAccess="organizations/statistics">
                        <OrganizationsStatistics />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    exact
                    path="/statistics-time"
                    element={
                      <ProtectedRoute requiredAccess="organizations/statistics">
                        <StatisticsTime />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    exact
                    path="/ogranizations-manager"
                    element={
                      <ProtectedRoute requiredAccess="ogranizations-manager">
                        <UnrealSoftManager />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    exact
                    path="/dashboard"
                    element={
                      <ProtectedRoute requiredAccess="dashboard">
                        <Dashboard />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    exact
                    path="/tables"
                    element={
                      <ProtectedRoute requiredAccess="tables">
                        <TablesInfo />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    exact
                    path="/areas"
                    element={
                      <ProtectedRoute requiredAccess="areas">
                        <AreasInfo />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    exact
                    path="/waiters"
                    element={
                      <ProtectedRoute requiredAccess="waiters">
                        <WaitersInfo />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    exact
                    path="/items"
                    element={
                      <ProtectedRoute requiredAccess="items">
                        <SalesInformation />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    exact
                    path="/mymenu-orders"
                    element={
                      <ProtectedRoute requiredAccess="mymenu-orders">
                        <MyMenuOrders />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    exact
                    path="/orders-execution"
                    element={
                      <ProtectedRoute requiredAccess="orders-execution">
                        <OrdersЕxecution />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    exact
                    path="/users-reports"
                    element={
                      <ProtectedRoute requiredAccess="users-reports">
                        <UsersReports />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    exact
                    path="/reports"
                    element={
                      <ProtectedRoute requiredAccess="reports">
                        <ReportsInfo />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    exact
                    path="/orders"
                    element={
                      <ProtectedRoute requiredAccess="orders">
                        <OrdersInfo />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    exact
                    path="/qr/users"
                    element={
                      <ProtectedRoute requiredAccess="qr/users">
                        <QRUsers />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    exact
                    path="/qr/management"
                    element={
                      <ProtectedRoute requiredAccess="qr/management">
                        <QRManagement />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    exact
                    path="/mymenu-survey"
                    element={
                      <ProtectedRoute requiredAccess="mymenu-survey">
                        <MyMenuSurvey />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    exact
                    path="/discount-management"
                    element={
                      <ProtectedRoute requiredAccess="discount-management">
                        <DiscountManagement />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    exact
                    path="/discounts-references"
                    element={
                      <ProtectedRoute requiredAccess="discounts-references">
                        <DiscountReferences />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    exact
                    path="/reservation"
                    element={
                      <ProtectedRoute requiredAccess="reservation">
                        <Reservations />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    exact
                    path="/reservation-overview"
                    element={
                      <ProtectedRoute requiredAccess="reservation-overview">
                        <ReservationsTableView />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    exact
                    path="/reservations-report"
                    element={
                      <ProtectedRoute requiredAccess="reservations-report">
                        <ReservationHistory />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    exact
                    path="/restaurant-scheme"
                    element={
                      <ProtectedRoute requiredAccess="restaurant-scheme">
                        <RestaurantSchema />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/menu/configuration"
                    element={
                      <ProtectedRoute requiredAccess="menu/configuration">
                        <MenuConfigurations />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/changelog"
                    element={
                      <ProtectedRoute requiredAccess="changelog">
                        <Changelog />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/tables-efficiency"
                    element={
                      <ProtectedRoute requiredAccess="tables-efficiency">
                        <TablesEfficiency />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/product-profitability"
                    element={
                      <ProtectedRoute requiredAccess="product-profitability">
                        <ProductProfitability />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    path="/invoices"
                    element={
                      <ProtectedRoute requiredAccess="invoices">
                        <Invoices />
                      </ProtectedRoute>
                    }
                  />
                </>
              )}
            </Route>

            {/* Auth Routes */}
            <Route
              exact
              path="/signin"
              element={
                <ProtectAuthRouter>
                  <SignIn />
                </ProtectAuthRouter>
              }
            />
            <Route
              exact
              path="/signup"
              element={
                <ProtectAuthRouter>
                  <SignUp />
                </ProtectAuthRouter>
              }
            />
            <Route
              exact
              path="/forgotpassword"
              element={
                <ProtectAuthRouter>
                  <ForgotPassword />
                </ProtectAuthRouter>
              }
            />
          </Routes>
        </Router>
      </StateProvider>
    </Provider>
  );
};

export default App;
